import * as actions from './actions';
import reducers from './reducer';

export const Follow = { actions, reducers };
export { FollowState } from './reducer';
